import React from 'react';
import { UNIVERSITY_IDS } from 'src/common/accountIds';
export var PageTitle = function (_a) {
    var pageTitle = _a.pageTitle, universityName = _a.universityName, universityId = _a.universityId;
    if (!pageTitle && (universityId === UNIVERSITY_IDS.SHEFELD_HALLAM || universityId === UNIVERSITY_IDS.TEST_UNI_2)) {
        return null;
    }
    return React.createElement("h2", { className: "page-title" }, pageTitle || "Ask us about what life at ".concat(universityName, " is really like"));
};
